import { CatalogOperatorPage } from "./CatalogOperatorPage";

const CatalogOperator = () => {
	return <CatalogOperatorPage />;
};
export default CatalogOperator;
